import gsap, { Power3 } from 'imports/gsap'
import siteCommon from 'site/site-common'
import soundtrack from 'site/soundtrack'
let score = {
    total_tracks:0,
    current_track:-1,
    mp3:null,
    seektime:0,
    is_playing:false,
    doAutoPlay:false,
    init:function () {
        var self = this;
        $('#score.film-block .soundtrack-module .soundtrack-list li .icon').on('click',self.listClick);
        score.total_tracks=$('#score.film-block .soundtrack-module .soundtrack-list li').length;
        score.current_track=-1;
        self.reset();
    },//init

    reset:function() {
        //set all icons to paused
        $('#score.film-block .soundtrack-module .soundtrack-list li').addClass('state_paused');
        $('#score.film-block .soundtrack-module .soundtrack-player .wave').hide();
        $('#score.film-block .soundtrack-module .soundtrack-player .wave.off').show();
    },

    stopSound:function(noLoop= false) {
        if (typeof(score.mp3) !== 'undefined' && score.mp3 !== null) {
            score.mp3.pause();
            score.is_playing=false;
            $('#score.film-block .soundtrack-module .soundtrack-player .wave').hide();
            $('#score.film-block .soundtrack-module .soundtrack-player .wave.off').show();
            score.setPauseIcon();
        }
        if (!noLoop) {
            score.stopSound(true)
        }
    },
    resumeSound:function() {
        if (typeof(score.mp3) !== 'undefined' && score.mp3 !== null) {
            score.mp3.play();
            score.is_playing = true;
            $('#score.film-block .soundtrack-module .soundtrack-player .wave').hide();
            $('#score.film-block .soundtrack-module .soundtrack-player .wave.on').show();
            score.setPlayIcon();
        }
    },
    playSound:function(mp3file) {
        if (typeof(score.mp3) !== 'undefined' && score.mp3 !== null) {
            score.mp3.removeEventListener("ended", score.soundEnded);
            score.stopSound();
            score.mp3.currentTime = 0;
        }
        score.mp3 = new Audio(mp3file);
        score.mp3.addEventListener("ended", score.soundEnded);
        score.mp3.addEventListener("timeupdate", score.soundUpdate);
        score.mp3.play();
        score.is_playing=true;

        $('#score.film-block .soundtrack-module .soundtrack-player .wave').hide();
        $('#score.film-block .soundtrack-module .soundtrack-player .wave.on').show();

        //icon
        score.setPlayIcon()

        //player
        score.initNewPlayer()
    },

    setPlayIcon:function() {
        //reset others
        $('#score.film-block .soundtrack-module .soundtrack-list li').removeClass('state_playing');
        $('#score.film-block .soundtrack-module .soundtrack-list li').addClass('state_paused');

        //set icon
        $('#score.film-block .soundtrack-module .soundtrack-list li').eq( score.current_track ).addClass('state_playing');
        $('#score.film-block .soundtrack-module .soundtrack-list li').eq( score.current_track ).removeClass('state_paused');
    },
    setPauseIcon:function() {
        //reset others
        $('#score.film-block .soundtrack-module .soundtrack-list li').removeClass('state_playing');
        $('#score.film-block .soundtrack-module .soundtrack-list li').addClass('state_paused');

        //set icon
        $('#score.film-block .soundtrack-module .soundtrack-list li').eq( score.current_track ).removeClass('state_playing');
        $('#score.film-block .soundtrack-module .soundtrack-list li').eq( score.current_track ).addClass('state_paused');
    },

    soundUpdate:function() {
        if (score.mp3) {
            var disp_ct,disp_duration,pct;
            var ogpct = score.mp3.currentTime/score.mp3.duration;
            if (score.mp3.currentTime>0) {
                disp_ct = siteCommon.toHHMMSS(score.mp3.currentTime);
                disp_duration = siteCommon.toHHMMSS(score.mp3.duration);
                pct = 100*ogpct;
            } else {
                disp_ct="";
                disp_duration="";
                pct = 0;
            }
            $('#score.film-block #score-time-current span').html(disp_ct);
            $('#score.film-block #score-time-duration span').html(disp_duration);
            $('#score.film-block .scrubbar-pct').css('width',pct+"%");
            //$('#scrubbar-dot').css('left',pct+"%");

            var maxw = $('#score.film-block .scrubbar-dot-container').width();
            var thex = ogpct * maxw - 9;
            $('#score.film-block li.active .scrubbar-dot-inner').css('left',thex+"px");
        }

    },

    jumpToPct:function(pct) {
        score.seektime = parseFloat(score.mp3.duration * pct);
        score.mp3.currentTime = score.seektime;
        score.mp3.addEventListener("playing", score.soundPlaying);
        score.resumeSound();
    },

    soundPlaying:function() {
        score.mp3.removeEventListener("playing", score.soundPlaying);
        score.mp3.currentTime = score.seektime;
    },

    soundEnded:function() {
        score.current_track++;
        if (score.current_track>=score.total_tracks) {
            score.current_track=0;
        }
        score.setSongFromIndex();
    },
    listClick:function() {
        soundtrack.stopSound(true)

        const parent = $(this).closest('li')
        const newindex = $('#score.film-block .soundtrack-module .soundtrack-list li').index(parent);
        if (newindex === score.current_track) {
            if (score.is_playing) {
                //stop
                score.stopSound();
            } else {
                //resume
                score.resumeSound();
            }
        } else {
            //new track
            var thex = -9;
            $('#score.film-block .scrubbar-dot-inner').removeClass('notdragged')
            $('#score.film-block .scrubbar-dot-inner').css('left',thex+"px");
            $('#score.film-block .scrubbar-dot-inner').addClass('notdragged')
            score.current_track = newindex;
            score.setSongFromIndex();
        }





    },
    setSongFromIndex:function() {
        score.soundUpdate()
        $('#score.film-block .soundtrack-module .soundtrack-list li').removeClass('active');
        $('#score.film-block .soundtrack-module .soundtrack-list li').eq( score.current_track ).addClass('active');
        var mp3file = $('#score.film-block .soundtrack-module .soundtrack-list li').eq( score.current_track ).attr('mp3');
        score.playSound(mp3file);
        score.setPlayIcon()

        //$( "#score.film-block li" ).draggable({
        $( "#score.film-block .drag-hook" ).draggable({
            axis: "x",
            containment: "parent",
            cursor: 'move',
            drag: function(event,ui){
                if (typeof(score.mp3) !== 'undefined' && score.mp3 !== null) {
                    $('#score.film-block .drag-hook').removeClass('notdragged')
                    score.stopSound()
                    return true
                } else {
                    return false
                }
            },
            stop: function( event, ui ) {
                if (typeof(score.mp3) !== 'undefined' && score.mp3 !== null) {
                    var maxw = $('#score.film-block .scrubbar-dot-container').width()
                    var thex = siteCommon.pxToNum($('#score.film-block .scrubbar-dot-inner').css('left'))
                    var pct = thex / maxw
                    $('#score.film-block .drag-hook').addClass('notdragged')
                    score.jumpToPct(pct)
                }
            }
        })
    },

    startAutomatically:function() {
        if (filmObject.section !== 'song' && filmObject.section !== 'score') {
            score.doAutoPlay = true
        }
        if (score.doAutoPlay) {
            score.current_track = 0
            score.setSongFromIndex()
        }
        score.doAutoPlay = true
    },

    initNewPlayer:function() {
        //clear old
        $('#score.film-block .soundtrack-module .soundtrack-list li .hook-player').html('')

        //add new player
        let thtml = $('#score.film-block .film-soundtrack-meta').html()
        $('#score.film-block .soundtrack-module .soundtrack-list li.active .hook-player').html(thtml)

        //reveal
        gsap.fromTo('#score.film-block .soundtrack-player', 2,
            {
                opacity: 0
            },
            {
                opacity: 1,
                ease: Power3.easeOut
            }
        );

    }
}
export default score
